// Import the functions you need from the SDKs you need
import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as isAnalyticsSupported,
  type Analytics,
} from "firebase/analytics";
import {
  getMessaging,
  isSupported as isMessagingSupported,
  type Messaging,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDZy2s0xrrGH2zqCDx2r5V4ZiCOqF7T5s8",
  authDomain: "mee-marriage.firebaseapp.com",
  projectId: "mee-marriage",
  storageBucket: "mee-marriage.firebasestorage.app",
  messagingSenderId: "782190610452",
  appId: "1:782190610452:web:c73ff0a394486515d1bf01",
  measurementId: "G-CR2MERZE2N",
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  isAnalyticsSupported()
    .then((supported: boolean) => {
      if (supported) {
        getAnalytics(app);
      }
    })
    .catch((error: unknown) => {
      console.error("Firebase analytics initialization failed", error);
    });
}

// Messaging instance cache
let messagingPromise: Promise<Messaging | null> | null = null;

export const getFirebaseMessaging = async (): Promise<Messaging | null> => {
  if (typeof window === "undefined") {
    return null;
  }

  if (!messagingPromise) {
    messagingPromise = isMessagingSupported()
      .then((supported: boolean) => (supported ? getMessaging(app) : null))
      .catch((error: unknown) => {
        console.error("Firebase messaging initialization failed", error);
        return null;
      });
  }

  return messagingPromise;
};
